<div
  [class]="`flex flex-row gap-2 ${!child() ? customClass() : ''} ${alignItems()}`"
  [ngClass]="{
    'p-2': !child()
  }"
>
  @for (toolbarItem of items(); track $index) {
    @switch (toolbarItem.type) {
      @case ("group") {
        @let groupItem = asGroup(toolbarItem);

        <div class="flex flex-col gap-1">
          <span class="uppercase text-xxs text-slate-400">{{
            groupItem.title()
          }}</span>

          <snoots-page-generic-toolbar
            [child]="true"
            [items]="groupItem.items()"
            [toolbarIntegrations]="[]"
          ></snoots-page-generic-toolbar>
        </div>
      }
      @case ("divider") {
        <div class="w-px bg-slate-200 self-stretch"></div>
      }
      @case ("action-group") {
        @let actionGroupItem = asActionGroup(toolbarItem);

        <div class="flex flex-col gap-1">
          <span class="uppercase text-xxs text-slate-400">{{
            actionGroupItem.title()
          }}</span>

          <div class="flex flex-row gap-2">
            @for (action of actionGroupItem.actions(); track $index) {
              <snt-button-icon
                [icon]="action.icon()!"
                [title]="action.title()!"
                [disabled]="action.disabled()"
                (onClickAsync)="action.onClickAsync.emit($event)"
              ></snt-button-icon>
            }
          </div>
        </div>
      }
      @case ("switch") {
        @let switchItem = asSwitch(toolbarItem);

        <div class="flex flex-col gap-1">
          <div>
            <span class="uppercase text-xxs text-slate-400">&nbsp;</span>
          </div>

          <div class="flex flex-row gap-2">
            <div class="flex flex-row gap-2 items-center">
              <dx-switch
                [switchedOffText]="''"
                [switchedOnText]="''"
                (onValueChanged)="switchItem.onValueChanged($any($event).value)"
              ></dx-switch>

              @if (switchItem.label()) {
                <span class="text-xs text-slate-900">
                  {{ switchItem.label() }}
                </span>
              }
            </div>
          </div>
        </div>
      }
      @case ("custom") {
        @if (asCustom(toolbarItem).template()?.templateRef) {
          <ng-container
            [ngTemplateOutlet]="asCustom(toolbarItem).template()!.templateRef"
            ]
          ></ng-container>
        }
      }
      @case ("card") {
        @let _cardItem = asCard(toolbarItem);

        <div
          class="rounded-md p-2 flex flex-col gap-8 aspect-video h-full {{
            _cardItem.bgColor() || 'bg-slate-200'
          }}"
        >
          <div class="flex flex-row">
            <div
              class="flex-1 flex flex-row items-start justify-start whitespace-nowrap"
            >
              <span
                class="text-sm  {{
                  _cardItem.secondaryTextColor() || 'text-slate-400'
                }}"
                >{{ _cardItem.label() }}</span
              >
            </div>
          </div>

          <div class="flex-1 flex flex-row items-end justify-stretch">
            <div class="flex-1 flex flex-row items-end justify-start">
              @if (_cardItem.value()) {
                <i
                  class="{{ _cardItem.icon() }} {{
                    _cardItem.secondaryTextColor() || 'text-slate-400'
                  }} text-[24px] opacity-75"
                ></i>
              }
            </div>

            <div class="flex flex-row items-end justify-end text-2xl">
              <span
                class="{{
                  _cardItem.textColor() || 'text-slate-900'
                }} text-3xl leading-6"
                >{{ _cardItem.value() }}</span
              >
            </div>
          </div>
        </div>
      }
      @case ("daterange") {
        @let _dateRangeItem = asDateRange(toolbarItem);

        <div class="flex flex-row gap-2">
          <snt-daterange-picker
            [customPresets]="_dateRangeItem.presets() || {}"
            [placeholder]="_dateRangeItem.title() || ''"
            (select)="_dateRangeItem.range.emit($event)"
            (clear)="_dateRangeItem.range.emit(null)"
            class="w-80"
          ></snt-daterange-picker>
        </div>
      }
    }
  }

  @let _toolbarIntegrations = toolbarIntegrations();

  @if (_toolbarIntegrations.length > 0) {
    <div class="w-px bg-slate-200 self-stretch"></div>

    @for (toolbarIntegrationItem of _toolbarIntegrations; track $index) {
      <div class="flex flex-col gap-1">
        <div class="flex flex-row items-center gap-1">
          <div>
            <img
              [src]="toolbarIntegrationItem.icon"
              crossOrigin
              class="h-4 w-4"
            />
          </div>

          <div>
            <span class="uppercase text-xxs text-slate-400">
              {{ toolbarIntegrationItem.title }}
            </span>
          </div>
        </div>

        <div class="flex flex-row gap-2">
          @for (
            actionRendered of toolbarIntegrationItem.actionsRendered;
            track $index
          ) {
            @let _rendered = actionRendered.rendered;
            <snt-button-icon
              [disabled]="_rendered.disabled"
              [icon]="_rendered.icon"
              [title]="_rendered.label"
              (onClickAsync)="
                toolbarIntegrationItemOnClickAsync(
                  $event,
                  actionRendered.action
                )
              "
            ></snt-button-icon>
          }
        </div>
      </div>
    }
  }
</div>
